import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';

// Mount React app
const container = document.getElementById('game-container');
if (!container) {
  throw new Error('Could not find #game-container element');
}

const root = createRoot(container);
root.render(React.createElement(App));
